// extracted by mini-css-extract-plugin
export default {"submitWarningModal":"styles__submitWarningModal___Byxzz"};